// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop--MOgZM","modal":"modal--hziXJ","js-has-pseudo":"js-has-pseudo--wmtyo"};